module.exports = __webpack_public_path__ + "static/media/receta-21.28a06e56.png";